import React from "react";
import { FadeUp } from "./AnimationLibrary";

const VerificationOptions = props => {
	
	const mapOptionsFromApi = () => {
		if (props.optionsLoading) {
			return (
				<VerificationListItem
					theKey="checkingForOptions"
					tabIndex="1"
					heading="Checking for other options..."
					onClick={null}
					methodIconClassName=""
				/>
			);
		}

		return props.verificationOptions.map((option, index) => (
			<VerificationListItem
				key={option.id}
				theKey={option.id}
				tabIndex={index + 1}
				heading={option.label}
				details={option.value}
				onClick={() => props.handleSelectOption(option)}
				methodIconClassName={option.type}
				sendingCode={props.sendingCode}
				recommended={option.id === "personalEmail" ? true : false}
			/>
		));
	};


	return (
		<>
			<FadeUp delay="150">
				<div className="main-message-container">
					<h3>How should we verify your identity?</h3>
				</div>
			</FadeUp>
			<ul className="verification-list">
				<FadeUp delay="250">
					{mapOptionsFromApi()}
				</FadeUp>
				<FadeUp delay="350">
					<VerificationListItem
						theKey="alreadyHaveCode"
						tabIndex="2"
						heading="Already have a code?"
						onClick={() => props.handleSelectOption({ type: "entercode" })}
						methodIconClassName="enter-code"
					/>
				</FadeUp>
				<FadeUp delay="450">
					<VerificationListItem
						theKey="callHelpDesk"
						tabIndex="3"
						heading="Call the Service Desk"
						onClick={() => props.handleSelectOption({ type: "help" })}
						methodIconClassName="help-desk"
					/>
				</FadeUp>
			</ul>
		</>
	);
};


const VerificationListItem = (props) => {
	const heading = (
		<span className="method-details__heading">
			{props.sendingCode ? "Sending code..." : props.heading}
		</span>
	);

	const details = !props.sendingCode && props.details ? (
		<span className="method-details__identifier">{props.details}</span>
	) : '';

	return (
		<li key={props.theKey} tabIndex={props.tabIndex} className="verification-list__item" onClick={props.onClick}>
			<div className={`a-unset ${props.recommended ? "recommended" : ""}`}>
				<div className={`method-icon ${props.methodIconClassName}`}></div>
				<div className="method-details">
					{heading}
					{details}
				</div>
			</div>
		</li>
	);
};





export default VerificationOptions;
